import React from 'react';
import AdminLayout from '../../components/AdminLayout';
import ReviewMetricsDashboard from '../../components/ReviewMetricsDashboard';

export default function ReviewDashboardPage() {
  return (
    <AdminLayout>
      <ReviewMetricsDashboard />
    </AdminLayout>
  );
}
